export default {
  times: [
    '12:00AM',
    '12:30AM',
    '01:00AM',
    '01:30AM',
    '02:00AM',
    '02:30AM',
    '03:00AM',
    '03:30AM',
    '04:00AM',
    '04:30AM',
    '05:00AM',
    '05:30AM',
    '06:00AM',
    '06:30AM',
    '07:00AM',
    '07:30AM',
    '08:00AM',
    '08:30AM',
    '09:00AM',
    '09:30AM',
    '10:00AM',
    '10:30AM',
    '11:00AM',
    '11:30AM',
    '12:00PM',
    '12:30PM',
    '01:00PM',
    '01:30PM',
    '02:00PM',
    '02:30PM',
    '03:00PM',
    '03:30PM',
    '04:00PM',
    '04:30PM',
    '05:00PM',
    '05:30PM',
    '06:00PM',
    '06:30PM',
    '07:00PM',
    '07:30PM',
    '08:00PM',
    '08:30PM',
    '09:00PM',
    '09:30PM',
    '10:00PM',
    '10:30PM',
    '11:00PM',
    '11:30PM'
  ],
  minutes: ['00', '30'],
  recurrences: [
    {
      id: 'unknown',
      name: 'unknown'
    },
    {
      id: 'none',
      name: 'notRepeat'
    },
    {
      id: 'daily',
      name: 'daily'
    },
    {
      id: 'weekdays',
      name: 'weekdays'
    },
    {
      id: 'weekly',
      name: 'weekly'
    },
    {
      id: 'biWeekly',
      name: 'biweekly'
    },
    {
      id: 'monthly',
      name: 'monthly'
    }
  ],
  privateEvent: [
    {
      id: 0,
      state: false,
      name: 'public'
    },
    {
      id: 1,
      state: true,
      name: 'private'
    }
  ],
  menus: ['locationMenu', 'calendarMenu', 'peopleMenu', 'equipmentsMenu', 'buildingMenu', 'profileMenu'],
  deviceIcon: {
    tablet: 'tablet',
    sensor: 'settings_remote',
    beacon: 'bluetooth'
  },
  uiConfig: {
    hasContactForm: true,
    culture: 'portuguese',
    cardConfigurations: [
      {
        hasSensor: true,
        busy: true,
        booked: true,
        status: 'unavailable'
      },
      {
        hasSensor: true,
        busy: true,
        booked: false,
        status: 'occupied'
      },
      {
        hasSensor: true,
        busy: false,
        booked: true,
        status: 'possibly'
      },
      {
        hasSensor: true,
        busy: false,
        booked: false,
        status: 'available'
      },
      {
        hasSensor: false,
        busy: false,
        booked: true,
        status: 'unavailable'
      },
      {
        hasSensor: false,
        busy: false,
        booked: false,
        cardColor: '#4BA135',
        status: 'available'
      }
    ]
  },
  oneDayMs: 86400000,
  roomsLimit: 9,
  roles: {
    ClientAdmin: 'client_admin',
    GlobalAdmin: 'global_admin',
    BookingAdmin: 'booking_admin',
    BookingApprover: 'booking_approver',
    ServiceDesk: 'service_desk'
  },
  serviceDeskStatus: {
    waiting: 'waiting',
    approved: 'approved',
    rejected: 'rejected',
    partiallyApproved: 'partiallyApproved',
    partiallyRejected: 'partiallyRejected',
    notAssigned: 'notAssigned'
  },
  serviceDeskStatusColor: {
    waiting: 'md-pending',
    approved: 'md-primary',
    rejected: 'md-error',
    partiallyApproved: 'md-pending',
    partiallyRejected: 'md-pending',
    notAssigned: 'md-pending'
  },
  serviceDeskStatusText: {
    waiting: 'waitingBySupplier',
    approved: 'approvedBySupplier',
    rejected: 'rejectedBySupplier',
    partiallyApproved: 'partiallyApprovedBySupplier',
    partiallyRejected: 'partiallyRejectedBySupplier',
    notAssigned: 'notAssigned'
  },
  supplierItemsType: {
    food: 'food',
    equipment: 'equipment'
  },
  supplierItemsTypePlural: {
    food: 'foods',
    equipment: 'equipments'
  },
  supplierItemsDialogTitle: {
    foods: 'Food',
    equipments: 'Equipment'
  },
  supplierItemsEmptyIcon: {
    foods: 'restaurant_menu',
    equipments: 'devices_other'
  },
  eventAuditLogAction: {
    created: "eventCreation",
    updated: "eventEditing",
    deleted: "eventCancelledByUser",
    approved: "eventApproval",
    rejected: "eventRejection",
    serviceApproved: "acceptanceOrderBySupplier",
    serviceRejected: "refusalOrderBySupplier",
    supplierUpdated: "supplierUpdated",
  },
  customIcon: {
    teams_room: 'microsoftteams.svg'
  },
  eventTypes: [
    {
      id: '1',
      name: 'eventTypeOther'
    },
    {
      id: '2',
      name: 'eventTypeBrokersLunch'
    },
    {
      id: '3',
      name: 'eventTypeConsortiumAssembly'
    },
    {
      id: '4',
      name: 'eventTypeChristmasDinner'
    },
    {
      id: '5',
      name: 'eventTypeHrCourse'
    },
    {
      id: '6',
      name: 'eventTypeExternalEvent'
    },
    {
      id: '7',
      name: 'eventTypeLecture'
    },
    {
      id: '8',
      name: 'eventTypeBrokersMeeting'
    },
    {
      id: '9',
      name: 'eventTypeCollaboratorsMeeting'
    },
    {
      id: '10',
      name: 'eventTypeProvidersMeeting'
    },
    {
      id: '11',
      name: 'eventTypeCollaboratorsTraining'
    },
    {
      id: '12',
      name: 'eventTypeProvidersTraining'
    },
    {
      id: '13',
      name: 'eventTypeBrokersTraining'
    },
    {
      id: '14',
      name: 'eventTypeWorkshop'
    },
    {
      id: '15',
      name: 'eventTypeIntervalLock'
    }
  ],
  eventTypeIntervalLockId: 99,
  approvalNotFoundErrors: {
    calendarconfigurationnotfound: 'calendarNotFoundOrInvalid',
    organizereventnotfound: 'organizerEventNotFound',
  },
  meetingProviderTypes: [
    {
      calendar: 'googleCalendar',
      types: [
        {
          name: 'googleMeet',
          isNecessaryKey: false,
          isDefaultMeet: true
        },
        {
          name: 'zoom',
          isNecessaryKey: true
        }
      ],
      calendarName: 'Google Calendar'
    },
    {
      calendar: 'microsoftCalendar',
      types: [
        {
          name: 'microsoftTeams',
          isNecessaryKey: false,
          isDefaultMeet: true
        }
      ],
      calendarName: 'Microsoft Calendar'
    },
    {
      calendar: 'exchangeOnPremises',
      calendarName: 'Exchange OnPremises Calendar'
    },
  ],
  eventStatus: [
    {value: 'booked', label: 'booked'},
    {value: 'protectedByAdmin', label: 'protectedByAdmin'},
    {value: 'shortenedOrCanceled', label: 'shortenedOrCanceled'},
    {value: 'canceledDueAbandonment', label: 'canceledDueAbandonment'},
    {value: 'canceledDueNoShow', label: 'canceledDueNoShow'},
    {value: 'rejected', label: 'eventRejected'},
    {value: 'checkedIn', label: 'checkedIn'},
  ]
}
